<template>
    <v-row class="rewards-grid mt-0 pt-3">
        <v-col v-for="(reward, k) in allRewards"
               :key="k"
               cols="4"
        >
            <coins v-if="reward.type === RewardType.COINS"
                   :quantity="reward.quantity"
            />
            <tickets v-else-if="reward.type === RewardType.TICKETS"
                     :quantity="reward.quantity"
            />
            <attribute-points v-else-if="reward.type === RewardType.ATTRIBUTE_POINTS"
                              :quantity="reward.quantity"
            />
            <ability-points v-else-if="reward.type === RewardType.ABILITY_POINTS"
                            :ability_id="reward.resource_id"
                            :quantity="reward.quantity"
            />
            <character-points v-else-if="reward.type === RewardType.CHARACTER_POINTS"
                              :character_id="reward.resource_id"
                              :quantity="reward.quantity"
            />
        </v-col>
    </v-row>
</template>

<script setup>
    import {computed} from "vue";
    import {storeToRefs} from "pinia";
    import {useMainStore} from "@/store";
    import {RewardType} from "@/enums";
    import AbilityPoints from "@/components/Currencies/AbilityPoints";
    import AttributePoints from "@/components/Currencies/AttributePoints";
    import CharacterPoints from "@/components/Currencies/CharacterPoints";
    import Coins from "@/components/Currencies/Coins";
    import Tickets from "@/components/Currencies/Tickets";

    const props = defineProps({
        rewards: {
            type: Array,
        },
    });

    const store = useMainStore();
    const {references} = storeToRefs(store);

    const rewardsReferences = computed(() => references.value.data === null || references.value.data.design === undefined || references.value.data.design.reward === undefined
        ? []
        : references.value.data.design.reward);

    const allRewards = computed(() => {
        // TODO: SORT BY REWARD TYPE
        // TODO: REDUCE BY REWARD TYPE / RESOURCE
        return props.rewards.map(reward => {
            const reference = rewardsReferences.value.find(r => r.id === reward.id);
            // The reward type comes from the design reference. The resource,
            // however, is taken from the granted reward when present: rewards
            // whose resource is determined at grant time (e.g. ability points
            // for the ability actually used) carry the resolved resource_id on
            // the reward itself, while the design reference's resource_id is
            // null. Fall back to the reference only when the grant did not
            // carry one (statically-configured rewards).
            const resource_id = reward.resource_id ?? (reference ? reference.resource_id : null);
            return {
                'type': reference ? reference.reward_type_id : null,
                'resource_id': resource_id,
                'quantity': reward.quantity,
            };
        });
    });
</script>

<style scoped>
    /*
     * Reward grid gutters, matching the Scoreboard stats grid (8px columns and
     * rows). Overrides Vuetify's default 24px gutter via its CSS gap vars so
     * reward cards sit tight wherever this component is used.
     */
    .rewards-grid {
        --v-col-gap-x: 8px;
        --v-col-gap-y: 8px;
    }
</style>
